import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { MONTH } from '@/Module/Core/Constant';
import type { ICategory } from '@/Module/Grade/Model/DataModel';
import { CategoryService } from '@/Module/Grade/Service';

export const CategoryListQuery = createApi({
  reducerPath: 'categoryListQuery',
  baseQuery: fetchBaseQuery({ baseUrl: 'unused' }),
  endpoints: builder => ({
    getCategoryList: builder.query<ICategory[], void>({
      queryFn: (_, { signal }) => {
        return CategoryService.getCategoryList(
          {
            pageNo: 0,
            pageCount: 100,
          },
          signal,
        )
          .then(({ data: { data } }) => ({ data }))
          .catch(error => ({ error }));
      },
      keepUnusedDataFor: MONTH,
    }),
  }),
});

export const {
  useGetCategoryListQuery,
  endpoints: { getCategoryList },
} = CategoryListQuery;
